/* eslint-disable */
import { Box, Warehouse } from 'lucide-react';
import { LANE_TYPES } from '@/Services/lane.services';

export { LANE_TYPES };

// How each lane type shows on screen. PACKING is the original lane - the
// backend still calls it just "lane"; only the display says "Packing Lane".
export const LANE_TYPE_META = {
	[LANE_TYPES.PACKING]: {
		label: 'Packing Lane',
		plural: 'Packing Lanes',
		Icon: Box,
		chipClass: 'border-teal-200 bg-teal-50 text-teal-700',
		hoverClass: 'hover:bg-teal-50',
	},
	[LANE_TYPES.STORAGE]: {
		label: 'Storage Lane',
		plural: 'Storage Lanes',
		Icon: Warehouse,
		chipClass: 'border-sky-200 bg-sky-50 text-sky-700',
		hoverClass: 'hover:bg-sky-50',
	},
};

export const LANE_TYPE_LIST = [LANE_TYPES.PACKING, LANE_TYPES.STORAGE];

// The lane chip on order cards: icon + lane name; iconOnly when space is short
// (the type and name stay in the tooltip).
export const LaneChip = ({ laneType = LANE_TYPES.PACKING, name, iconOnly = false, className = '' }) => {
	const meta = LANE_TYPE_META[laneType] || LANE_TYPE_META[LANE_TYPES.PACKING];
	const { Icon } = meta;
	if (!name) return null;
	return (
		<span
			className={`inline-flex flex-shrink-0 items-center gap-1 whitespace-nowrap rounded-md border px-1.5 py-0.5 text-[10px] font-bold ${meta.chipClass} ${className}`}
			title={`${meta.label}: ${name}`}
		>
			<Icon size={11} className='flex-shrink-0' />
			{!iconOnly && name}
		</span>
	);
};
